"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _imageUpload = _interopRequireDefault(require("./imageUpload"));

var ImagesUpload = _react["default"].memo(function (props) {
  var path = props.path,
      list = props.list,
      onUploaded = props.onUploaded,
      onError = props.onError;
  return list.map(function (image) {
    return /*#__PURE__*/_react["default"].createElement(_imageUpload["default"], {
      key: image.name,
      path: path,
      image: image,
      onUploaded: onUploaded,
      onError: onError
    });
  });
});

ImagesUpload.propTypes = {
  path: _propTypes["default"].string,
  list: _propTypes["default"].array,
  onUploaded: _propTypes["default"].func,
  onError: _propTypes["default"].func
};
ImagesUpload.defaultProps = {
  path: undefined,
  list: [],
  onUploaded: function onUploaded() {},
  onError: function onError() {}
};
var _default = ImagesUpload;
exports["default"] = _default;